export function getImageUrl (path) {
  return `/assets/${path}`;
};
